module.exports = __webpack_public_path__ + "static/media/manhattan-night-mode.d4794a2c.jpg";